import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import {
    ButtonSharedModule,
    IconSharedModule,
    InputSharedModule,
    InputTooltipSharedModule,
} from "pf_styleguide";

import { PaymentFormService } from "../payment-form/payment-form.service";

import { ErrorsModule } from "../../../../../shared/module/errors/errors.module";
import { DiscountComponent } from "./discount.component";

@NgModule({
    declarations: [DiscountComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,

        ButtonSharedModule,
        IconSharedModule,
        InputSharedModule,
        InputTooltipSharedModule,
        ErrorsModule,
    ],
    exports: [DiscountComponent],
    providers: [PaymentFormService],
})
export class DiscountModule {}
